export default {"src":"/_next/static/media/navlogo.a51e961d.svg","height":169,"width":557,"blurWidth":0,"blurHeight":0};